import React, { useState } from "react";
import "./App.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

function App() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // "success" | "error" | "already"
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const res = await fetch(`${API_URL}/api/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.status === 201) {
        setStatus("success");
        setEmail("");
      } else if (res.status === 200) {
        setStatus("already");
      } else {
        setStatus("error");
      }
      setMessage(data.message || data.error);
    } catch {
      setStatus("error");
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      {/* Nav */}
      <nav className="nav">
        <span className="logo">DeFence<span className="logo-accent">MMA</span></span>
      </nav>

      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <p className="hero-tag">Computer Vision for MMA</p>
          <h1 className="hero-title">
            See the fight.<br />
            <span className="hero-highlight">Not the fence.</span>
          </h1>
          <p className="hero-desc">
            Project DeFence removes cage fences from MMA footage in real time, giving you
            an unobstructed view of every strike, takedown, and submission.
          </p>

          <form className="subscribe-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="subscribe-input"
            />
            <button type="submit" className="subscribe-btn" disabled={loading}>
              {loading ? "Joining..." : "Sign Up for Updates"}
            </button>
          </form>

          {status && (
            <p className={`subscribe-msg ${status}`}>{message}</p>
          )}
        </div>

        <div className="hero-image">
          <video src="/images/demo.mp4" autoPlay loop muted playsInline />
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2026 DeFence MMA. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
